<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
body {
  // color: #fff;
  // width: 100vw;
  // height: 100vh;
  // overflow: hidden;
  // font-size: 14px;
  // background: url("./assets/images/background.jpg") no-repeat;
  // background-size: 100% 100%;
  // line-height: 1;
  // font-family: "Microsoft YaHei";
  // background-size: cover;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // .el-cascader__dropdown,.el-cascader-menu{
  //   border: 1px solid #333942 !important;
  // }
  // .el-cascader-panel,.el-popper{
  //   background: #000103 !important;
  // }
  // .n-checked-path{
  //   color: #fff !important;
  // }
}
#app{
  width: 100%;
  height: 100%;
}
</style>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      onload: false
    };
  },
  computed: {
    // ...mapGetters([
    //   'app',
    // ]),
  },
  created() {
    // 获取用户信息
    // this.$store.dispatch("user/getMemberByToken").then(() => {
    //   this.onload = true;
    // });
  }
};
</script>
